// extracted by mini-css-extract-plugin
export default {"wrapper":"Contacts_wrapper__hW-5n","header":"Contacts_header__j2GDz","goBack":"Contacts_goBack__nEEQs","container":"Contacts_container__TbN1b"};